.MuiAutocomplete-popper {
    li + li {
        border-top: 1px solid #bbb;
    }
}

.MuiAutocomplete-popperDisablePortal {
    position: static !important;
}
